module.exports = __webpack_public_path__ + "school/img/theoryDetailBg.67939bc2.jpg";